// 导入请求数据的 request 模块
import request from '@/utils/request'

// 根据省份、专业、年级查询资讯信息
export const SelectInformation = (province, major, grade, classify, currentPage, pageSize) => {
  return request.get('/information/select', {
    params: {
      province: province,
      major: major,
      grade: grade,
      classify: classify,
      currentPage: currentPage,
      pageSize: pageSize
    }
  })
}

// 根据学校名称查询资讯信息
export const SelectInformationSchoolName = (schoolname, currentPage, pageSize) => {
  return request.get('/information/select/schoolname', {
    params: {
      schoolname: schoolname,
      currentPage: currentPage,
      pageSize: pageSize
    }
  })
}

// 根据资讯名称查询资讯信息
export const SelectInformationDataName = (filename, currentPage, pageSize) => {
  return request.get('/information/select/dataname', {
    params: {
      filename: filename,
      currentPage: currentPage,
      pageSize: pageSize
    }
  })
}
